import { Box, Grid } from "@mui/material";
import { AppImages } from "app/appImages";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { PublicationListType } from "generated/CoreApi_v1";
import { Formaters } from "lib/Formaters";
import { useTranslation } from "react-i18next";
import { useCardContext } from "../../CardBuilder";

///
export const ListSystemLeftThumbnail = () => {
    const { pub: { listDefinition } } = useCardContext();

    let thumbnailUrl;
    if (listDefinition) {
        if (listDefinition.listType == PublicationListType.Favorite)
            thumbnailUrl = AppImages.KnowledgeListFavoriteThumbnail;
        else if (listDefinition.listType == PublicationListType.SeeLater)
            thumbnailUrl = AppImages.KnowledgeListSeeLaterThumbnail;
    }

    return (
        <Box sx={{ width: 154, height: 87 }}>
            <img src={thumbnailUrl} width="100%" height="100%" style={{ objectFit: "contain", borderRadius: "6px" }} />
        </Box>
    );
};


///
export const ListSystemAuthor = () => {
    const { pub } = useCardContext();
    const { t } = useTranslation("knowledge");

    return (
        <Grid container justifyContent="center" alignItems="center" spacing={1}>
            <Grid size="grow">
                <MprcFeedTypography variant="authorPrimary" component="div">
                    <span title={t("Feed.Card.List.PrivateListText")}>{t("Feed.Card.List.PrivateListText")}</span>
                </MprcFeedTypography>

                {pub.listDefinition?.lastUpdateItemsDate &&
                    <MprcFeedTypography variant="authorSecondary" component="div">
                        <span>{t("Feed.Card.List.UpdatedOnText")} {" "} {Formaters.relativeTime(pub.listDefinition?.lastUpdateItemsDate)}</span>
                    </MprcFeedTypography>
                }
            </Grid>
        </Grid>
    );
};
